import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RoutingHelperService {
    allowAnonymous = false;
    outletOnly = false;

    private readonly _subjectOutletOnly: Subject<boolean> = new Subject();

    isAllowAnonymousAcess() {
        return this.allowAnonymous;
    }

    setAllowAnonymous(allowAnonymous: boolean) {
        this.allowAnonymous = allowAnonymous;
    }

    setOutletOnly(outletOnly: boolean) {
        this.outletOnly = outletOnly;
        this._subjectOutletOnly.next(outletOnly);
    }

    resetRouteParameters() {
        this.outletOnly = false;
        this.allowAnonymous = false;
    }

    isOutletOnly(): Subject<boolean> {
        return this._subjectOutletOnly;
    }
}
